module.exports = __webpack_public_path__ + "img/logo.85fbc364.png";